import { GetPurchaseHistoryApiParameter } from "@GeriMed/Services/PurchaseHistoryService";
import ApplicationStateGeriMed from "@GeriMed/Store/GeriMedState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { createContext } from "react";

// export function getPurchaseHistoryDataView(state: ApplicationStateGeriMed) {
//     const data = getDataView(state.dataPurchaseHistoryState,undefined);
//     return data;
// }
export function getPurchaseHistoryDataView(state: ApplicationStateGeriMed, parameter: GetPurchaseHistoryApiParameter) {
    const data = getDataView(state.dataPurchaseHistory,parameter);
    return data;
}

export const PurchaseHistoryDataViewContext = createContext<ReturnType<typeof getPurchaseHistoryDataView>>({
    value: undefined,
    isLoading: false,
});
